import { Container, Row, Col } from "react-bootstrap";
import emo_category_icon from "../../images/emo_category.png";
import FEAI_icon from "../../images/FEAI_icon.png";
import Learning_AI from "../../images/learning_ai.png";
import fer2013_sneak_peak from "../../images/fer2013_sneak_peak.png";
import fer2013_distributions from "../../images/fer2013_distributions.png";
import MouseHoverInfoTooltip from "./MouseHoverInfoTooltip";
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import affectnet_sample from "../../images/affectnet_sample.png"
import Thinking_AI from "../../images/AI_thinking.png"
import welcome_ai from "../../images/Welcome_ai.png"

import ResNet50ArchitectureTooltip from "./ResNet50ArchitectureTooltip";
import icon_one from "../../images/introPageIcon.png"
import icon_two from "../../images/introPageIcon2.png"
import icon_three from "../../images/introPageIcon3.png"
import icon_step_one from "../../images/step_one.png"
import icon_step_two from "../../images/step_two.png"
import icon_step_three from "../../images/step-three.png"
import icon_step_four from "../../images/step-four.png"
import gradcam_sample from "../../images/gradcam.png";
import guided_gradcam_sample from "../../images/guided_gradcam.png";
import dataset_explain from "../../images/dataset_explain.jpg"

import './StudyOneInstruction.css'
import { steps } from "framer-motion";

const rootStyles = getComputedStyle(document.documentElement);
const data = [
    { name: 'Surprise', value: 5.0 },
    { name: 'Sad', value: 8.9 },
    { name: 'Happy', value: 46.3},
    { name: 'Fear', value: 2.4 },
    { name: 'Disgust', value: 1.5},
    { name: 'Angry', value: 8.7 },
    { name: 'contempt', value: 1.5 },
    { name: 'Neutral', value: 25.9 },
  ];

const COLORS = [
    rootStyles.getPropertyValue('--surprised-color').trim(),  
    rootStyles.getPropertyValue('--sad-color').trim(),        
    rootStyles.getPropertyValue('--happy-color').trim(),      
    rootStyles.getPropertyValue('--fearful-color').trim(),    
    rootStyles.getPropertyValue('--disgusted-color').trim(),  
    rootStyles.getPropertyValue('--angry-color').trim(), 
    rootStyles.getPropertyValue('--contempt-color').trim(),      
    rootStyles.getPropertyValue('--neutral-color').trim(),    
  ];
  const renderCustomLabel = ({ percent, name, value }) => {
    return `${value}%`;
  };

export default function StudyOneInstructionPageOne(){
    return (
        <Container 
            fluid 
            className="d-flex justify-content-center align-items-center" 
            style={{ height: "100vh" }}
        >
            <Row className="text-center" style={{ width: "100%", justifyContent: "center" }}>
                <Col md={12}>
                    <h1 style={{ fontWeight: 'bold', fontSize: '3rem' }}>Introduce Yourself!</h1>
                    <br /><br />
                </Col>
                <Col xs={12} md={4} className="d-flex justify-content-center">
                    <img 
                        src={welcome_ai} 
                        alt="FEAI icon" 
                        style={{ width: "300px", height: "300px", borderRadius: "50%" }} 
                    />
                </Col>
                <Col xs={12} md={6} className="d-flex align-items-center justify-content-center">
                    <div 
                        className="chat-bubble" 
                        style={{
                            fontSize: "1.5rem",
                            padding: "20px",
                            borderRadius: "15px",
                            backgroundColor: "#f0f0f0",
                            maxWidth: "80%",
                            boxShadow: "0px 4px 10px rgba(0,0,0,0.1)"
                        }}
                    >
                        <p>Hi, What's your name?</p>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};